import React from 'react';
import {
    Link,
  } from "react-router-dom";

const Navbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
  <div className="container-fluid">
    <img alt='Not Found' src='https://th.bing.com/th/id/OIP.qX2Lf8sq1pCB8P3QHToDuwAAAA?rs=1&pid=ImgDetMain' style={{height: '40px', width: '50px', cursor: 'pointer'}}></img>
    <Link className="navbar-brand mx-3" to="/"><b>ItxSahil</b></Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link className="nav-link active" aria-current="page" to="/ex">Explore</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/abt">About</Link>
        </li>
      </ul>
      <form className="d-flex" role="search">
        {/* <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" /> */}
        <button className="btn btn-outline-success" type="submit" style={{height: '40px', width: '100px'}}><b>Sign Up</b></button>
      </form>
    </div>
  </div>
</nav>
    </div>
  )
}

export default Navbar
